import { combine, withCallbacks, withContext } from 'react-hooks-combine'
import { ROLES } from 'constants/account.roles'
import { spec, validators } from 'utils/validation'
import { withFormModel } from 'shared/hooks'
import { ServicesContext } from 'services/context'

import SignupFormComponent from './component'

const { string, any, custom } = validators

export default combine(
  withContext(
    'jurisdictionsService',
    ServicesContext,
    ({ jurisdictionsService }) => jurisdictionsService
  ),
  withFormModel(
    {
      email: {
        alias: 'Email',
        spec: spec.flow(
          string.isString,
          string.isEmail,
          string.isNotEmpty,
          any.required
        ),
      },

      nickName: {
        alias: 'Nickname',
        spec: spec.flow(string.isString, string.isNotEmpty, any.required),
      },

      password: {
        alias: 'Password',
        spec: spec.flow(string.isString, string.isNotEmpty, any.required),
      },

      confirmation: {
        alias: 'Password Confirmation',
        spec: spec.flow(
          string.isString,
          custom.matchProp('password'),
          string.isNotEmpty,
          any.required
        ),
      },

      firstName: {
        alias: 'First name',
        spec: spec.flow(string.isString, string.isNotEmpty, any.required),
      },
      lastName: {
        alias: 'Last name',
        spec: spec.flow(string.isString, string.isNotEmpty, any.required),
      },
      address1: {
        alias: 'address1',
        spec: spec.flow(string.isString),
      },
      address2: {
        alias: 'address2',
        spec: spec.flow(string.isString),
      },
      city: {
        alias: 'city',
        spec: spec.flow(string.isString),
      },
      state: {
        alias: 'state',
        spec: spec.flow(string.isString),
      },
      zip: {
        alias: 'zip',
        spec: spec.flow(string.isString),
      },
      country: {
        alias: 'country',
        spec: spec.flow(),
      },
    },
    { id: 'signup-form' }
  ),

  withCallbacks(
    {
      getOptionLabel:
        () =>
          ({ name }) =>
            name,
      getOptionValue:
        () =>
          ({ id }) =>
            id,

      loadJurisdictions:
        ({ jurisdictionsService }) =>
          (search = '') =>
            jurisdictionsService.getJurisdictionsPublic({ search }),

      onSubmitForm: {
        deps: ['onSubmit'],
        func:
          (_state, { onSubmit }) =>
            (entity) => {
              const mapToServerFormat = () => {
                const {
                  address1,
                  address2,
                  zip,
                  country,
                  state,
                  city,
                  firstName,
                  lastName,
                  email,
                  password,
                  website,
                  nickName,
                } = entity

                return {
                  firstName,
                  lastName,
                  nickName,
                  email,
                  password,
                  website,
                  address: {
                    address1,
                    address2,
                    zip,
                    country: country?.name || '',
                    state,
                    city,
                  },
                }
              }
              const updatedData = mapToServerFormat()
              return onSubmit({ type: ROLES.USER, entity: updatedData })
            },
      },
    },
    []
  )
)(SignupFormComponent)
